<div class="row mt-3">
  <div class="col-lg-12 mb-2">
    <h5>Data Management</h5>
  </div>
  <div class="col-lg-12">
    <div class="row">
      <div class="col-lg-12">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item"> <a class="nav-link active" data-toggle="tab" href="#resources" role="tab"><span class="hidden-sm-up"><i class="ti-user"></i></span>
          <span class="hidden-xs-down">Resources</span></a> </li>
          <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#sow" role="tab"><span class="hidden-sm-up"><i class="ti-user"></i></span>
          <span class="hidden-xs-down">SOW</span></a> </li>
          <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#manualtimesheet" role="tab"><span class="hidden-sm-up"><i class="ti-user"></i></span>
          <span class="hidden-xs-down">Manual Timesheet</span></a> </li>
          <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#forecast" role="tab"><span class="hidden-sm-up"><i class="ti-user"></i></span>
          <span class="hidden-xs-down">Forecast</span></a> </li>
          <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#receipts" role="tab"><span class="hidden-sm-up"><i class="ti-user"></i></span>
          <span class="hidden-xs-down">Receipts</span></a> </li>
        </ul>
      </div>
      <div class="col-lg-12">
        <div class="tab-content tabcontent-border">
          <div class="tab-pane white-bg active" id="resources" role="tabpanel">
            <div class="row p-3">
              <div class="col-lg-12">
                <div class="card card_dash">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-2"><h3>Resources List</h3></div>
                      <div class="col-lg-3"></div>
                      <div class="col-lg-2"></div>
                      <div class="col-lg-2">
                        <input [(ngModel)]="search.filter" class="form-control" id="" type="text"
                          placeholder="Name Search" (input)="onInputChange($event)" />
                        </div>
                        @if (edit == 1) {
                          <div class="col-lg-1">
                            <span class="btn btn-sm waves-effect btn-block btn-secondary" role='button'
                              (click)="onEditNewRrc()">
                              EDIT
                            </span>
                          </div>
                          <div class="col-lg-1">
                            <span class="btn btn-sm waves-effect btn-block btn-danger claroredbg" role='button'
                              (click)="onAddNewRrc()">
                              ADD
                            </span>
                          </div>
                        }
                        <div class="col-lg-12 table-responsive">
                          <p-table
                            [value]="resourceList"
                            [paginator]="true"
                            [totalRecords]="totalRecords"
                            [rowsPerPageOptions]='[10,25,50]'
                            [rows]="10"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="Total: {totalRecords} records"
                            [tableStyle]="{'min-width': '50rem', 'font-size': '1rem'}"
                            (onPage)=onPageChange($event)
                            [lazy]="true"
                            [loading]="loading"
                            [scrollable]="true"
                            class="table-dark"
                            >
                            <ng-template pTemplate="header" let-columns>
                              <tr>
                                @if (edit == 1) {
                                  <th scope="col" class="ng-table-header">SELECT</th>
                                }
                                <th class="ng-table-header">RESOURCE ID</th>
                                <th class="ng-table-header">NAME</th>
                                <th class="ng-table-header">EMAIL</th>
                                <th class="ng-table-header">ADP ID</th>
                                <th class="ng-table-header">EXTERNAL</th>
                                <th class="ng-table-header">EMPLOYER</th>
                                <th class="ng-table-header">DEPARTMENT</th>
                                <th class="ng-table-header">ACTIVE</th>
                                <th class="ng-table-header">BILLABLE</th>
                                <th class="ng-table-header">CONTRACT</th>
                                <th class="ng-table-header">TEAM</th>
                                <th class="ng-table-header">CHAPTER</th>
                                <th class="ng-table-header">PRIMARY TASK</th>
                                <th class="ng-table-header">TYPE</th>
                                <th class="ng-table-header">CAPEX CODE</th>
                                <th class="ng-table-header">ADP LEVEL</th>
                                <th class="ng-table-header">ADP DEPARTMENT</th>
                                <th class="ng-table-header">UNIT</th>
                                <th class="ng-table-header">ID DR</th>
                                <th class="ng-table-header">ME ID</th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns">
                              <tr class="ng-table-body">
                                @if (edit == 1) {
                                  <td scope="col" class="text-center">
                                    <input type="radio" name="radio[]" (change)="selected(rowData)" />
                                  </td>
                                }
                                <td class="text-center">{{ rowData.RESOURCE_ID }}</td>
                                <td class="text-center">{{ rowData.PAYROLL_NAME }}</td>
                                <td class="text-center">{{ rowData.USEREMAIL }}</td>
                                <td class="text-center">{{ rowData.ADP_ID }}</td>
                                <td class="text-center">{{ rowData.EXTERNAL }}</td>
                                <td class="text-center">{{ rowData.EMPLOYERDESC == null ? rowData.EMPLOYER : rowData.EMPLOYERDESC }}</td>
                                <td class="text-center">{{ rowData.DEPARTMENT }}</td>
                                <td class="text-center">{{ rowData.ACTIVE }}</td>
                                <td class="text-center">{{ rowData.BILLABLE }}</td>
                                <td class="text-center">{{ rowData.CONTRACTDESC == null ? rowData.CONTRACT : rowData.CONTRACTDESC  }}</td>
                                <td class="text-center">{{ rowData.TEAMDESC == null ? rowData.TEAM : rowData.TEAMDESC  }}</td>
                                <td class="text-center">{{ rowData.CHAPTER }}</td>
                                <td class="text-center">{{ rowData.PRIMARY_CAPEX_TASK }}</td>
                                <td class="text-center">{{ rowData.TYPE }}</td>
                                <td class="text-center">{{ rowData.CAPEXCODE }}</td>
                                <td class="text-center">{{ rowData.ADPLEVEL }}</td>
                                <td class="text-center">{{ rowData.ADP_DEPARTMENT }}</td>
                                <td class="text-center">{{ rowData.UNIT }}</td>
                                <td class="text-center">{{ rowData.ID_DR }}</td>
                                <td class="text-center">{{ rowData.ME_USERID }}</td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="6">Records not found!</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane white-bg" id="sow" role="tabpanel">
              <div class="row p-3">
                <div class="col-lg-12">
                  <div class="card card_dash">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-2"><h3>SOW List</h3></div>
                        <div class="col-lg-3"></div>
                        <div class="col-lg-2"></div>
                        <div class="col-lg-2">
                          <input [(ngModel)]="searchSow.filter" class="form-control" id="" type="text"
                            placeholder="Name Search" (input)="onInputChangeSow($event)" />
                          </div>
                          @if (edit == 1) {
                            <div class="col-lg-1">
                              <span class="btn btn-sm waves-effect btn-block btn-secondary" role='button'
                                (click)="onEditNewSow()">
                                EDIT
                              </span>
                            </div>
                            <div class="col-lg-1">
                              <span class="btn btn-sm waves-effect btn-block btn-danger claroredbg" role='button'
                                (click)="onAddNewSow()">
                                ADD
                              </span>
                            </div>
                          }
                          <div class="col-lg-12 table-responsive">
                            <p-table
                              [value]="sowList"
                              [paginator]="true"
                              [totalRecords]="totalRecordsSow"
                              [rowsPerPageOptions]='[10,25,50]'
                              [rows]="10"
                              [showCurrentPageReport]="true"
                              currentPageReportTemplate="Total: {totalRecords} records"
                              [tableStyle]="{'min-width': '50rem', 'font-size': '1rem'}"
                              (onPage)=onPageChangeSow($event)
                              [lazy]="true"
                              [loading]="loading"
                              [scrollable]="true"
                              class="table-dark"
                              >
                              <ng-template pTemplate="header" let-columns>
                                <tr>
                                  @if (edit == 1) {
                                    <th scope="col" class="ng-table-header">SELECT</th>
                                  }
                                  <th class="ng-table-header">NAME</th>
                                  <th class="ng-table-header">RESOURCE ID</th>
                                  <th class="ng-table-header">PO NUMBER</th>
                                  <th class="ng-table-header">PO LINE</th>
                                  <th class="ng-table-header">START DATE</th>
                                  <th class="ng-table-header">END DATE</th>
                                  <th class="ng-table-header"></th>
                                </tr>
                              </ng-template>
                              <ng-template pTemplate="body" let-rowData let-columns="columns">
                                <tr class="ng-table-body">
                                  @if (edit == 1) {
                                    <td scope="col" class="text-center">
                                      <input type="radio" name="radio[]" (change)="selectedSow(rowData)" />
                                    </td>
                                  }
                                  <td scope="col" class="text-center">{{ rowData.USERNAME }}</td>
                                  <td scope="col" class="text-center">{{ rowData.RESOURCE_ID }}</td>
                                  <td scope="col" class="text-center">{{ rowData.PONUMBER }}</td>
                                  <td scope="col" class="text-center">{{ rowData.POLINEDESCRIPTION }}</td>
                                  <td scope="col" class="text-center">{{ rowData.START_DATE }}</td>
                                  <td scope="col" class="text-center">{{ rowData.END_DATE }}</td>
                                  @if (rowData.FILENAME?.length > 0) {
                                    <td scope="col" class="text-center">
                                      <button class="btn btn-sm btn-secondary" (click)="onDownload(rowData)">
                                        <i class="fa fa-download"></i>
                                      </button>
                                    </td>
                                  } @else {
                                    <td scope="col" class="text-center"></td>
                                  }
                                </tr>
                              </ng-template>
                              <ng-template pTemplate="emptymessage">
                                <tr>
                                  <td colspan="6">Records not found!</td>
                                </tr>
                              </ng-template>
                            </p-table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane white-bg" id="manualtimesheet" role="tabpanel">
                <div class="row p-3">
                  <div class="col-lg-12">
                    <div class="card card_dash">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-lg-4"><h3>Manual Time Entry List</h3></div>
                          <div class="col-lg-3"></div>
                          <div class="col-lg-2">
                            <input [(ngModel)]="searchManualTS.filter" class="form-control" id="" type="text"
                              placeholder="Name Search" (input)="onInputChangeManualTimeSheet($event)" />
                            </div>
                            @if (edit == 1) {
                              <div class="col-lg-1">
                                <span class="btn btn-sm waves-effect btn-block btn-secondary" role='button'
                                  (click)="onEditNewManualTS()">
                                  EDIT
                                </span>
                              </div>
                              <div class="col-lg-1">
                                <span class="btn btn-sm waves-effect btn-block btn-danger claroredbg" role='button'
                                  (click)="onAddNewManualTS()">
                                  ADD
                                </span>
                              </div>
                            }
                            <div class="col-lg-12 table-responsive">
                              <p-table
                                [value]="manualTSList"
                                [paginator]="true"
                                [totalRecords]="totalRecordsManualTS"
                                [rowsPerPageOptions]='[10,25,50]'
                                [rows]="10"
                                [showCurrentPageReport]="true"
                                currentPageReportTemplate="Total: {totalRecords} records"
                                [tableStyle]="{'min-width': '50rem', 'font-size': '1rem'}"
                                (onPage)=onPageChangeManualTimeSheet($event)
                                [lazy]="true"
                                [loading]="loading"
                                [scrollable]="true"
                                class="table-dark"
                                >
                                <ng-template pTemplate="header" let-columns>
                                  <tr>
                                    @if (edit == 1) {
                                      <th scope="col" class="ng-table-header">SELECT</th>
                                    }
                                    <th class="ng-table-header">NAME</th>
                                    <th class="ng-table-header">EPIC</th>
                                    <th class="ng-table-header">FEATURE</th>
                                    <th class="ng-table-header">TIME</th>
                                    <th class="ng-table-header">YEAR</th>
                                    <th class="ng-table-header">MONTH</th>
                                    <th class="ng-table-header">TEAM</th>
                                    <th class="ng-table-header">RESOURCE ID</th>
                                    <th class="ng-table-header">MONTHLY COST</th>
                                    <th class="ng-table-header">ORGANIZATION</th>
                                  </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns">
                                  <tr class="ng-table-body">
                                    @if (edit == 1) {
                                      <td scope="col" class="text-center">
                                        <input type="radio" name="radio[]" (change)="selectedManualTimeSheet(rowData)" />
                                      </td>
                                    }
                                    <td scope="col" class="text-center">{{ rowData.USER }}</td>
                                    <td scope="col" class="text-center">{{ rowData.EPIC_TITLE }}</td>
                                    <td scope="col" class="text-center">{{ rowData.FEATURE_TITLE }}</td>
                                    <td scope="col" class="text-center">{{ rowData.EFFECTIVE_TIME }}</td>
                                    <td scope="col" class="text-center">{{ rowData.YEAR }}</td>
                                    <td scope="col" class="text-center">{{ rowData.MONTH }}</td>
                                    <td scope="col" class="text-center">{{ rowData.TEAMDESC == null ? rowData.TEAM : rowData.TEAMDESC }}</td>
                                    <td scope="col" class="text-center">{{ rowData.RESOURCE_ID }}</td>
                                    <td scope="col" class="text-center">{{ rowData.MONTHLY_COST }}</td>
                                    <td scope="col" class="text-center">{{ rowData.ORGANIZATION }}</td>
                                  </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                  <tr>
                                    <td colspan="6">Records not found!</td>
                                  </tr>
                                </ng-template>
                              </p-table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane white-bg" id="forecast" role="tabpanel">
                  <div class="row p-3">
                    <div class="col-lg-12">
                      <div class="card card_dash">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-lg-4"><h3>Forecast</h3></div>
                            <div class="col-lg-3"></div>
                            <div class="col-lg-2">
                              <input [(ngModel)]="searchForecast.filter" class="form-control" id="" type="text"
                                placeholder="Name Search" (input)="onInputChangeForecast($event)" />
                              </div>
                              @if (edit == 1) {
                                <div class="col-lg-1">
                                  <span class="btn btn-sm waves-effect btn-block btn-secondary" role='button'
                                    (click)="onEditForecast()">
                                    EDIT
                                  </span>
                                </div>
                                <div class="col-lg-1">
                                  <span class="btn btn-sm waves-effect btn-block btn-danger claroredbg" role='button'
                                    (click)="onAddNewForecast()">
                                    ADD
                                  </span>
                                </div>
                              }
                              <div class="col-lg-12 table-responsive">
                                <p-table
                                  [value]="forecastList"
                                  [paginator]="true"
                                  [totalRecords]="totalRecordsForecast"
                                  [rowsPerPageOptions]='[10,25,50]'
                                  [rows]="10"
                                  [showCurrentPageReport]="true"
                                  currentPageReportTemplate="Total: {totalRecords} records"
                                  [tableStyle]="{'min-width': '50rem', 'font-size': '1rem'}"
                                  (onPage)=onPageChangeForecast($event)
                                  [lazy]="true"
                                  [loading]="loading"
                                  [scrollable]="true"
                                  class="table-dark"
                                  >
                                  <ng-template pTemplate="header" let-columns>
                                    <tr>
                                      @if (edit == 1) {
                                        <th scope="col" class="ng-table-header">SELECT</th>
                                      }
                                      <th class="ng-table-header">NAME</th>
                                      <th class="ng-table-header">EPIC</th>
                                      <th class="ng-table-header">FEATURE</th>
                                      <th class="ng-table-header">TIME</th>
                                      <th class="ng-table-header">YEAR</th>
                                      <th class="ng-table-header">MONTH</th>
                                      <th class="ng-table-header">TEAM</th>
                                      <th class="ng-table-header">RESOURCE ID</th>
                                      <th class="ng-table-header">MONTHLY COST</th>
                                      <th class="ng-table-header">ORGANIZATION</th>
                                    </tr>
                                  </ng-template>
                                  <ng-template pTemplate="body" let-rowData let-columns="columns">
                                    <tr class="ng-table-body">
                                      @if (edit == 1) {
                                        <td scope="col" class="text-center">
                                          <input type="radio" name="radio[]" (change)="selectedForecast(rowData)" />
                                        </td>
                                      }
                                      <td scope="col" class="text-center">{{ rowData.USER }}</td>
                                      <td scope="col" class="text-center">{{ rowData.EPIC_TITLE }}</td>
                                      <td scope="col" class="text-center">{{ rowData.FEATURE_TITLE }}</td>
                                      <td scope="col" class="text-center">{{ rowData.EFFECTIVE_TIME }}</td>
                                      <td scope="col" class="text-center">{{ rowData.YEAR }}</td>
                                      <td scope="col" class="text-center">{{ rowData.MONTH }}</td>
                                      <td scope="col" class="text-center">{{ rowData.TEAMDESC == null ? rowData.TEAM : rowData.TEAMDESC }}</td>
                                      <td scope="col" class="text-center">{{ rowData.RESOURCE_ID }}</td>
                                      <td scope="col" class="text-center">{{ rowData.MONTHLY_COST }}</td>
                                      <td scope="col" class="text-center">{{ rowData.ORGANIZATION }}</td>
                                    </tr>
                                  </ng-template>
                                  <ng-template pTemplate="emptymessage">
                                    <tr>
                                      <td colspan="6">Records not found!</td>
                                    </tr>
                                  </ng-template>
                                </p-table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane white-bg" id="receipts" role="tabpanel">
                    <div class="row p-3">
                      <div class="col-lg-12">
                        <div class="card card_dash">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-lg-4"><h3>Receipts</h3></div>
                              <div class="col-lg-3"></div>
                              <div class="col-lg-2">
                                <input [(ngModel)]="searchReceipts.filter" class="form-control" id="" type="text"
                                  placeholder="Name Search" (input)="onInputChangeReceipts($event)" />
                                </div>
                                <div class="col-lg-1">
                                  <span class="btn btn-sm waves-effect btn-block btn-secondary" role='button'
                                    (click)="onEditReceipts()">
                                    EDIT
                                  </span>
                                </div>
                                <div class="col-lg-1">
                                  <span class="btn btn-sm waves-effect btn-block btn-danger claroredbg" role='button'
                                    (click)="onAddNewReceipts()">
                                    ADD
                                  </span>
                                </div>
                                <div class="col-lg-12 table-responsive">
                                  <p-table
                                    [value]="receiptsList"
                                    [paginator]="true"
                                    [totalRecords]="totalRecordsReceipts"
                                    [rowsPerPageOptions]='[10,25,50]'
                                    [rows]="10"
                                    [showCurrentPageReport]="true"
                                    currentPageReportTemplate="Total: {totalRecords} records"
                                    [tableStyle]="{'min-width': '50rem', 'font-size': '1rem'}"
                                    (onPage)=onPageChangeReceipts($event)
                                    [lazy]="true"
                                    [loading]="loading"
                                    [scrollable]="true"
                                    class="table-dark"
                                    >
                                    <ng-template pTemplate="header" let-columns>
                                      <tr>
                                        @if (edit == 1) {
                                          <th scope="col" class="ng-table-header">SELECT</th>
                                        }
                                        <th class="ng-table-header">CONTRACTOR</th>
                                        <th class="ng-table-header">VENDOR</th>
                                        <th class="ng-table-header">PO</th>
                                        <th class="ng-table-header">PO LINE</th>
                                        <th class="ng-table-header">PO LINE DESC</th>
                                        <th class="ng-table-header">YEAR</th>
                                        <th class="ng-table-header">MONTH</th>
                                        <th class="ng-table-header">QUANTITY</th>
                                        <th class="ng-table-header">RECEIPT NUMBER</th>
                                        <th class="ng-table-header">INVOICE</th>
                                        <th class="ng-table-header">CONTRACTOR ID</th>
                                      </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                                      <tr class="ng-table-body">
                                        @if (edit == 1) {
                                          <td scope="col" class="text-center">
                                            <input type="radio" name="radio[]" (change)="selectedReceipts(rowData)" />
                                          </td>
                                        }
                                        <td scope="col" class="text-center">{{ rowData.RESOURCE_NAME }}</td>
                                        <td scope="col" class="text-center">{{ rowData.VENDOR }}</td>
                                        <td scope="col" class="text-center">{{ rowData.PONUMBER }}</td>
                                        <td scope="col" class="text-center">{{ rowData.PO_LINE_NO }}</td>
                                        <td scope="col" class="text-center">{{ rowData.PO_LINE_DESK }}</td>
                                        <td scope="col" class="text-center">{{ rowData.YEAR }}</td>
                                        <td scope="col" class="text-center">{{ rowData.MONTH }}</td>
                                        <td scope="col" class="text-center">{{ rowData.QUANTITY }}</td>
                                        <td scope="col" class="text-center">{{ rowData.RECEIPT_NUMBER }}</td>
                                        <td scope="col" class="text-center">{{ rowData.INVOICE }}</td>
                                        <td scope="col" class="text-center">{{ rowData.CONTRACTOR_ID }}</td>
                                      </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                      <tr>
                                        <td colspan="6">Records not found!</td>
                                      </tr>
                                    </ng-template>
                                  </p-table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
